import { Component, Input, OnInit, inject } from '@angular/core'
import { RecordActionPanelService } from '@app/feature/record-actions-panel/record-action-panel.service'
import { AddFieldComponent } from '@app/feature/add-field/add-field.component'
import { ManageFieldsComponent } from '@app/feature/manage-fields/manage-fields.component'
import { ManageFieldsService } from '@app/feature/manage-fields/manage-fields.service'
import { TbDividerComponent } from '@components-library/tb-divider/tb-divider.component'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { TbMenuListComponent } from '@components-library/tb-menu-list/tb-menu-list.component'
import { TbMenuListItemComponent } from '@components-library/tb-menu-list-item/tb-menu-list-item.component'
import { ModalFlowManagerService } from '@components-library/tb-modal-manager/modal-flow-manager.service'
import { getBoolean } from '@core/global-util'
import { AddFieldData, Field, RecordGroup } from '@models/ui'
import { TranslocoModule } from '@jsverse/transloco'
import { FieldFacadeService, FieldTypeFacadeService } from '@services/store-facade'
import { switchMap, take } from 'rxjs/operators'
import { ModalContainerTypes } from '@components-library/tb-modal-manager/modal-manager.service'
import { of, combineLatest } from 'rxjs'

@Component({
    selector: 'app-board-column-header-menu',
    imports: [
        TbDividerComponent,
        TbIconComponent,
        TbMenuListComponent,
        TbMenuListItemComponent,
        TranslocoModule,
    ],
    templateUrl: './board-column-header-menu.component.html',
})
export class BoardColumnHeaderMenuComponent implements OnInit {
    private readonly actionPanelService = inject(RecordActionPanelService)
    private readonly modalFlowManagerService = inject(ModalFlowManagerService)
    private readonly fieldFacadeService = inject(FieldFacadeService)
    private readonly fieldTypeFacadeService = inject(FieldTypeFacadeService)
    private readonly manageFieldsService = inject(ManageFieldsService)

    @Input({ required: true }) data!: any
    @Input() containerLayout!: ModalContainerTypes

    group!: RecordGroup

    collapsed = false

    isDeleteAvailable = false

    ngOnInit() {
        this.group = this.data.columnItem
        this.collapsed = this.data.collapsed
        this.isDeleteAvailable = getBoolean(this.group.field?.operation_code_entity?.delete)
    }

    isAllGroupSelected(group: RecordGroup) {
        return this.actionPanelService.areSelected(group.data)
    }

    toggleGroup(selected: boolean, group: RecordGroup) {
        if (selected) {
            this.actionPanelService.selectRecords(group.data)
        } else {
            this.actionPanelService.deselectRecords(group.data)
        }
    }

    edit(field: Field) {
        this.modalFlowManagerService
            .openDialog<AddFieldComponent, AddFieldData, Field | undefined>({
                component: AddFieldComponent,
                data: {
                    ...field,
                },
            })
            .pipe(
                switchMap((field) => {
                    return combineLatest([
                        of(field),
                        this.fieldTypeFacadeService.selectFieldTypeEntities$,
                    ])
                }),
            )
            .subscribe(([field, filedTypes]) => {
                if (!field) return

                this.fieldFacadeService.updateField(field, filedTypes)
            })
    }

    delete(guid: string) {
        this.manageFieldsService.deleteField(guid, true).pipe(take(1)).subscribe()
    }

    manageFields() {
        this.modalFlowManagerService.openDialog({ component: ManageFieldsComponent })
    }
}
